export default {"src":"/_next/static/media/disconnect-image.a6f868bd.svg","height":3000,"width":4000};